import React from "react";
import {useNavigate} from "react-router-dom";
import styled from "styled-components";
import PageHeader from "../../components/organisms/PageHeader";
import map from "../../assets/images/map-bg.png";
import spot1 from "../../assets/images/mp-museum.png";
import spot2 from "../../assets/images/mp-dongsan.png";
import spot3 from "../../assets/images/mp-pond.png";
import spot4 from "../../assets/images/mp-cafe-1.png";
import spot5 from "../../assets/images/mp-walk.png";
import spot6 from "../../assets/images/mp-cafe-2.png";
import spot12 from "../../assets/images/mp-ground-1.png";
import spot13 from "../../assets/images/mp-ground-2.png";
import spot14 from "../../assets/images/mp-nature.png";
import MapTooltip from "../../components/atoms/MapTooltip";
import {device} from "../../assets/styles/media";
import {useMediaQuery} from "react-responsive";


const Section = styled.section`
    display: flex;
    margin-top: 60px;
    margin-bottom: 140px;
    h4 {
        display: none;
    }
    ${device.mobile} {
        margin-top: 30px;
        margin-bottom: 50px;
    }
`;

const MapBox = styled.div`
    position: relative;
    overflow: hidden;
    margin: -2vw auto 0;
`;
const MapBg = styled.img`
    width: 1440px;
    height: 750px;
    vertical-align: top;
    
    ${device.tablet}{
        width: 100%;
        height: auto;
    }
    ${device.mobile}{
        width: 100%;
        height: auto;
    }
`;

const MapSpot = styled.span`
    position: absolute;
    cursor: pointer;
    display: inline-block;
    left: ${(props) => props.left};
    top: ${(props) => props.top};
    width: ${({width}) => width};
    z-index: ${(props) => props.$zIndex};
    transition: 0.4s ease;
    img {
        transition: 0.4s ease;
        width: 100%;

        &:hover {
            transform: scale(1.1);
        }
    }
`;
const TooltipLabel = styled.div`
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    background: #322a6f;
    padding: 6px 10px;
    border-radius: 6px;
    font-size: 14px;
    color: #f5ab18;
    white-space: nowrap;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    z-index: 99;
    
    ${device.mobile}{
        zoom: 0.5;
    }
`;

const GuideMap = () => {
    const navigate = useNavigate();
    const isTablet = useMediaQuery({maxWidth: 1023});
    const navList = [
        { name: "박물관", link: "/map/museum" },
        { name: "네이처풀", link: "/map/naturepool" },
        { name: "산책", link: "/map/walkpath" },
        { name: "운동장", link: "/map/playground" },
        { name: "편의시설", link: "/map/facility" },
        { name: "먹거리", link: "/map/foodcourt" }
    ];
    const mapSpots = [
        {
            id: "map-spot1",
            text: "강아지숲 박물관",
            link: "/map/museum",
            imgSrc: spot1,
            left: "17.2%",
            top: "10%",
            width: "12%",
            delay: "0.9s",
            $zIndex: 1
        },
        {
            id: "map-spot2",
            text: "강아지숲 동산",
            link: "/map/walkpath",
            imgSrc: spot2,
            left: "28.1%",
            top: "6.5%",
            width: "14.8%",
            delay: "1.2s",
            $zIndex: 5
        },
        {
            id: "map-spot3",
            text: "강아지숲 연못",
            link: "/map/walkpath#pond",
            imgSrc: spot3,
            left: "16.9%",
            top: "30.3%",
            width: "15.2%",
            delay: "1.6s",
            // $zIndex: 3
        },
        {
            id: "map-spot4",
            text: "카페, 가을",
            link: "/map/foodcourt#cafe",
            imgSrc: spot4,
            left: "31.5%",
            top: "46.4%",
            width: "8%",
            delay: "2.2s",
            $zIndex: 6
        },
        {
            id: "map-spot5",
            text: "강아지숲 산책로",
            link: "/map/walkpath#walk",
            imgSrc: spot5,
            left: "30%",
            top: "6.2%",
            width: "28%",
            delay: "1.4s",
            $zIndex: 3
        },
        {
            id: "map-spot6",
            text: "카페, 겨울",
            link: "/map/foodcourt#cafe",
            imgSrc: spot6,
            left: "47.8%",
            top: "70.5%",
            width: "10%",
            delay: "1.7s",
            $zIndex: 2
        },
        {
            id: "map-spot12",
            text: "강아지숲 작은 운동장",
            link: "/map/playground",
            imgSrc: spot12,
            left: "62.3%",
            top: "61%",
            width: "14%",
            delay: "1.6s",
            $zIndex: 4
        },
        {
            id: "map-spot13",
            text: "강아지숲 큰 운동장",
            link: "/map/playground",
            imgSrc: spot13,
            left: "80.5%",
            top: "46.5%",
            width: "17.5%",
            delay: "1.9s",
            $zIndex: 4
        },
        {
            id: "map-spot14",
            text: "강아지숲 네이처풀",
            link: "/map/naturepool",
            imgSrc: spot14,
            left: "45.5%",
            top: "14.5%",
            width: "50%",
            delay: "1.9s",
            $zIndex: 3
        }
    ];

    return (
        <>
                <PageHeader
                    bTitle="관람"
                    detail="가이드맵"
                    desc="강아지숲 가이드맵을 안내해 드립니다."
                    list={navList}
                />
                <Section>
                    <h4>강아지숲 가이드맵 소개</h4>
                    <MapBox>
                        <MapBg src={map}/>
                        {mapSpots.map((spot) => (<>
                        {!isTablet && <MapTooltip
                                    id={spot.id}
                                />}
                                <MapSpot
                                    key={spot.id}
                                    onClick={() => navigate(spot.link)}
                                    style={{animationDelay: spot.delay}}
                                    left={spot.left}
                                    top={spot.top}
                                    width={spot.width}
                                    $zIndex={spot.$zIndex}
                                    data-tooltip-id={spot.id}
                                    data-tooltip-content={spot.text}
                                >
                                    <img src={spot.imgSrc} alt={spot.text}/>
                                    {isTablet && (
                                        <TooltipLabel>{spot.text}</TooltipLabel>
                                    )}
                                </MapSpot>
                            </>
                        ))}
                    </MapBox>
                </Section>
        </>
    );
};

export default GuideMap;
